/**
 * Utility functions for formatting data
 */

/**
 * Format a currency amount with its currency code
 * @param {number} amount - The amount to format
 * @param {string} currencyCode - The ISO 4217 currency code
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, currencyCode) => {
  if (amount === undefined || amount === null) return "N/A";

  try {
    // Format number with commas but no currency symbol
    const formattedAmount = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    // Return with ISO currency code
    return `${formattedAmount} ${currencyCode || "USD"}`;
  } catch (error) {
    console.error("Error formatting currency:", error);
    return `${amount.toFixed(2)} ${currencyCode || "USD"}`;
  }
};

/**
 * Format a timestamp to a readable date string
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Formatted date string
 */
export const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";

  try {
    const date = new Date(timestamp);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid Date";
  }
};

/**
 * Format a transaction type from kebab-case to Title Case
 * @param {string} type - The transaction type in kebab-case
 * @returns {string} Formatted transaction type
 */
export const formatTransactionType = (type) => {
  if (!type) return "N/A";

  return type
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
